import React, { useContext } from "react";

import Styles from "./Styles/PageCover.module.css";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../../Context/AuthContext";
import { CardContext } from "../../../../Context/CardContext";
import toast from "react-hot-toast";

const PageCover = React.forwardRef(
  ({ cover, purchase, position, bookId, price, title, quarterly }, ref) => {
    const { isLoggedIn } = useContext(AuthContext);
    const { addItem } = useContext(CardContext);
    const history = useHistory();
    const handleAddToCard = (item) => {
      if (!isLoggedIn) {
        toast.error("برای خرید لطفا ابتدا وارد حساب کاربر خود شوید");
      } else {
        const result = addItem(item);
        if (result) {
          toast.success(`کتاب ${item.text} با موفقیت به سبد خرید اضافه شد`);
          history.replace("/users/panel/cart");
        }
      }
    };
    return (
      <div ref={ref} className={Styles.cover}>
        {purchase || position === "front" ? (
          <img src={cover} alt="" />
        ) : (
          <>
            <h3>برای خواندن ادامه کتاب لطفا آنرا از بخش کتابخانه تهیه کنید</h3>
            <button
              onClick={() =>
                quarterly
                  ? handleAddToCard({
                      id: bookId,
                      price,
                      text: title,
                      kind: "quarterly",
                    })
                  : handleAddToCard({
                      id: bookId,
                      price,
                      text: title,
                      kind: "book",
                    })
              }
            >
              افزودن به سبد خرید
            </button>
          </>
        )}
      </div>
    );
  }
);

export default PageCover;
